import { NgModule } from '@angular/core';

import { Oauth2RoutingModule } from './oauth2-routing.module';
import { IdpresponseComponent } from './idpresponse/idpresponse.component';
import { SharedModule } from '../shared/shared.module';


@NgModule({
  declarations: [
    IdpresponseComponent
  ],
  imports: [
    Oauth2RoutingModule,
    SharedModule
  ]
})
export class Oauth2Module { }
